export const NAV_MENU_TEST_IDS = {
  NAV_MENU_CONTENT: 'nav-menu-content',
  NAV_MENU_CONTAINER: 'nav-menu-container',
  NAV_MENU_STACK: 'nav-menu-stack',
  NAV_MENU_ITEM_LABEL: 'nav-menu-item-{label}'
} as const
